<template>
  <el-dialog
    class="embeddDialog"
    :class="isHeaderBackground ? 'is-blank' : ''"
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
    :width="width"
    :append-to-body="appendToBody"
    :modal-append-to-body="appendToBody"
    :close-on-click-modal="false"
    :before-close="handleClose">
    <slot slot="title" name="title">

    </slot>
    <slot></slot>
    <slot slot="footer" class="dialog-footer" name="footer"></slot>
  </el-dialog>
</template>

<script>
  export default {
    props: {
      title: {
        type: [Number, String],
        default: '弹窗标题'
      },
      width: {
        type: String,
        default: '80%'
      },
      appendToBody: {
        type: Boolean,
        default: true
      },
      isHeaderBackground: {
        type: Boolean,
        default: false
      }
    },
    watch: {
     
    },
    data() {
      return {
      }
    },
    methods: {
      handleClose() {
        this.$emit('update:visible', false)
        this.$emit('handleClose')
      },
    }
  }
</script>

<style lang="less" scoped>
  .is-blank {
    /deep/  .el-dialog {
      .el-dialog__header {
        background: #fff !important;
        border-bottom: 1px solid #D9D9D9;
      }
    }
  }
  /deep/ .el-dialog__body {
    max-height: calc(~ "100% - 50px");
    overflow-x: hidden;
    scrollbar-width: thin;
  }
  /deep/ .head-warp {
    .icon-fullscreen {
      width: 16px;
      height: 16px;
      background: url('../../../assets/icon/fullscreen.png');
    }
    .fullscreen {
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 60px;
    }
  }
</style>